import './i18n'
import {
  useDynamicFormContent,
  useLanguage,
  useOneStop,
  useUtilities,
} from 'hooks'
import { useContext, useEffect, useState } from 'react'
import * as Sentry from '@sentry/react'
import { ApiFormId, ApiFormIdList } from 'common.types'
import { Form } from 'views/forms/Form'
import { GlobalStoreContext, globalStore } from './stores/GlobalStore'
import { OneStop } from 'components'

if (window.location.hostname !== 'localhost') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    tracesSampleRate: 0.1,
    ignoreErrors: [/reCAPTCHA/i],
  })
}

function AppInner() {
  useLanguage()
  const globalStore = useContext(GlobalStoreContext)
  const { conditionallyInitializeBlpaGtm } = useUtilities()
  const [formId, setFormId] = useState<ApiFormId | undefined>()
  const [showForm, setShowForm] = useState(false)
  let formIdToSet: ApiFormId = 'mail-in-ballot'
  const { isOneStop } = useOneStop()
  const { hasLoaded: dynamicFormContentLoaded } = useDynamicFormContent()
  useEffect(() => {
    conditionallyInitializeBlpaGtm()
    if (window.votepaFormId) {
      formIdToSet = window.votepaFormId as ApiFormId
    }
    const urlParams = new URLSearchParams(window.location.search)
    const formIdParam = urlParams.get('form')
    if (formIdParam && ApiFormIdList.includes(formIdParam as ApiFormId)) {
      formIdToSet = formIdParam as ApiFormId
    }
    if (isOneStop && !globalStore?.state?.initialPath) {
      globalStore?.setState({
        ...globalStore?.state,
        initialPath: window.location.pathname,
      })
    }

    setFormId(formIdToSet.replaceAll('_', '-') as ApiFormId)
  }, [])

  if (!dynamicFormContentLoaded) {
    return null
  }

  if (isOneStop) {
    return <div className="App">{<OneStop />}</div>
  }

  return <div className="App">{formId ? <Form apiName={formId} /> : null}</div>
}

function App() {
  return (
    <GlobalStoreContext.Provider value={globalStore}>
      <AppInner />
    </GlobalStoreContext.Provider>
  )
}

export default App
